import { getEndpoint } from "@components/config/helpers";
import globalActions from "@components/Redux/Global/actions";
import { useRouter } from "next/router";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useGeneralActions from "../useGeneralActions";


const useRoute = (initialData, exactRoute) => {

    const router = useRouter();
    const {template_settings} = useSelector((state) => state.globalReducer);
    const {categoryState} = useSelector((state) => state.categoryReducer);
    const [data, setData] = useState(initialData);
    const [route, setRoute] = useState(exactRoute)
    const [originalRoute, setOriginalRoute] = useState('');
    const initialState = useRef(true);
    const loading = useRef(false);
    const dispatch = useDispatch();
    const {setPageSpinner} = useGeneralActions();

    const buildQueryStringByType = (type, param) => {
        let str = `&${param}=`;
        if(typeof router?.query?.[type] != 'undefined' && router?.query?.[type]){
            str += router.query[type]
        }
        else {
            str = "";
        }
        return str;
    }

    const getProducts = async () => {
        const req = await fetch(`${process.env.BASE_API_URL}get-category?slug=${router.query.route}`); //find the category data from the url
        const data = await req.json();
        return data;
    }

    const getArticle = async () => {
        let queryStr = buildQueryStringByType('per_page', 'per_page');
            queryStr += buildQueryStringByType('page', 'page');
            queryStr += buildQueryStringByType('slug', 'year');
            queryStr += buildQueryStringByType('_slug_3', 'month');
            queryStr += buildQueryStringByType('_slug_4', 'day');
            queryStr += buildQueryStringByType('_slug_5', 'slug');

        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-articles?type=${router.query.route}${queryStr}`);
        const data = await req.json();
        return data;
    }
    const getLocation = async () => {
        
    }

    useEffect(() => {
        const handleRouteChange = async () => {
            if(!initialState.current && router.query.route != originalRoute ){
                let obj = {
                    route: router.query.route
                };
                const endpoint = await getEndpoint(obj)
                if(
                    endpoint == null 
                    // && categoryState?.category?.category_id
                ){
                    return;
                }

                loading.current = true;
                // setPageSpinner(true);
                
                let req;
                let newData;
                if(endpoint == null) {
                    newData = await getProducts();
                    setData(newData);
                    setRoute('category')
                }
                else if(router.query.route == 'location'){
                    req = await getLocation();
                    setData(newData);
                    setRoute('location');
                }
        
                else { //article
                    newData = await getArticle();
                    setData(newData);
                    setRoute('article');
                }

                dispatch({
                    type: globalActions.SET_GLOBAL_DATA,
                    payload: {
                        breadcrumbs: newData.breadcrumb,
                        sidenav: newData?.template_page_settings?.sidenav == 'yes' && template_settings.sidenav == 'yes'
                    }
                })
                setOriginalRoute(router.query.route);
                loading.current = false;
                // setPageSpinner(false);
            }
        };
        handleRouteChange();
    }, [router.query, router.query.route, router.events]);

    
    useEffect(() => {
        initialState.current = false;
        setOriginalRoute(router.query.route)
        // initBreadcrumbs()
        return () => {
            dispatch({
                type: globalActions.SET_GLOBAL_DATA,
                payload: {
                    sidenav: false
                }
            })
        }
    }, [])
    


    return {
        data,
        route,
        setData,
        setRoute,
        loading: loading.current
    }
}

export default useRoute;